module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', [(_vm.$auth.user()) ? _c('v-navigation-drawer', {
    attrs: {
      "app": "",
      "disable-resize-watcher": "true",
      "temporary": "true",
      "hide-overlay": "",
      "width": "200"
    },
    model: {
      value: (_vm.drawer),
      callback: function($$v) {
        _vm.drawer = $$v
      },
      expression: "drawer"
    }
  }, [_c('v-toolbar', {
    staticClass: "transparent",
    attrs: {
      "flat": ""
    }
  }, [_c('v-list', {
    staticClass: "pa-0"
  }, [_c('v-list-tile', {
    attrs: {
      "avatar": ""
    }
  }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(_vm.$auth.user().displayName || _vm.$auth.user().email))])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-list', [_c('v-list-tile', {
    on: {
      "click": function($event) {
        return _vm.$router.push('/projects-list')
      }
    }
  }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Проекты")])], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    on: {
      "click": function($event) {
        return _vm.$router.push('/account')
      }
    }
  }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Лицевой счет")])], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    on: {
      "click": function($event) {
        return _vm.$router.push('/update-profile')
      }
    }
  }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Профиль")])], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    on: {
      "click": function($event) {
        return _vm.$router.push('/faq')
      }
    }
  }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Вопросы и ответы")])], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    on: {
      "click": function($event) {
        return _vm.logout()
      }
    }
  }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Выйти")])], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-toolbar', {
    attrs: {
      "app": ""
    }
  }, [(_vm.$auth.user()) ? _c('v-toolbar-side-icon', {
    nativeOn: {
      "click": function($event) {
        _vm.drawer = !_vm.drawer
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('v-toolbar-title', [_vm._v("Fuelcrowd")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-toolbar-items', [(_vm.$auth.user()) ? _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.logout()
      }
    }
  }, [_vm._v("Выйти")]) : _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.login()
      }
    }
  }, [_vm._v("Войти")])], 1)], 1), _vm._v(" "), _c('v-content', [_c('v-container', [_c('router-view')], 1)], 1), _vm._v(" "), _c('v-footer', {
    attrs: {
      "app": ""
    }
  }, [_c('span', {
    staticClass: "text-center"
  }, [_vm._v("FuelCrowd © 2019")]), _vm._v(" "), _c('v-spacer')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-04590b76"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Layout.vue
// module id = 459
// module chunks = 1